import Cookies from 'js-cookie';
import { prepareExternalUrl } from '@/core/url/url.service';
import { SSOMessage } from '@/types/SSOMessage';

const APP_BASE_HREF = `${process.env.PUBLIC_URL}/`;
const currentSearchParams = window.location.search.split('?')[1];

const inIFrame = window !== window.top;

if (inIFrame) {
  const params = new URLSearchParams(currentSearchParams);
  const isLoginError = params.has('loginError');
  window.parent.postMessage(
    {
      type: isLoginError ? SSOMessage.ERROR : SSOMessage.SUCCESS,
      compatibilityValue: params.get('compatibility'),
    },
    window.location.origin,
  );
} else {
  window.history.pushState(null, '', `${APP_BASE_HREF}login-landing.html`);
  // Login via SW which also use window.open to redirect
  // Will cause cross-origin frame issue
  try {
    // When login via popup window, hand the control over to the popup opener.
    if (window.opener) {
      // For Desktop
      handOverToOpener();
    } else {
      // For Mobile and IE
      restoreSession();
    }
  } catch (e) {
    // For Login From SW
    restoreSession();
  }
}

function handOverToOpener() {
  try {
    window.opener.loginCallback();
    window.opener.loginCallback = null;
  } catch (e) {
    window.opener.location.reload();
  }

  window.close();
}

function restoreSession() {
  const previousSessionUrlKey = 'rcapw-previous_session_url';
  const defaultRedirectURL = '/';
  let previousSessionURL;

  previousSessionURL =
    getStoredSessionURL(previousSessionUrlKey) || defaultRedirectURL;
  previousSessionURL = prepareExternalUrl(previousSessionURL);
  window.location.href = adaptSearchParams(previousSessionURL);
}

function getStoredSessionURL(key) {
  const url = Cookies.get(key);

  if (url) Cookies.remove(key);

  return url;
}

function adaptSearchParams(url) {
  const isURLWithSearchParams = /.*\?(.+)/.test(url);

  if (currentSearchParams) {
    url = isURLWithSearchParams
      ? `${url}&${currentSearchParams}`
      : `${url}?${currentSearchParams}`;
  }

  return url;
}
